export default __webpack_public_path__ + "static/media/MobileStep2.092be067.svg";